import { Getter, ComputedGetters } from '@app/store/StoreUtil';
import Match from '@core/models/offer/Match';

type DEFAULT_USER_ID = 'defaultUserId';
export const DEFAULT_USER_ID : DEFAULT_USER_ID = 'defaultUserId';

export interface IFavouriteTeam {
    displayName: string;
    sportId: number;
    slug: string;
}

export interface IFavouriteTournament {
    displayName: string;
    id: number;
}

export type IFavouriteItem = IFavouriteTeam | IFavouriteTournament;

export interface IUserPreferences {
    favouriteTournaments: number[];
    favouriteMarkets: number[];
    pinnedEvents: number[];
}

export type IPreferencesState = Record<string, IUserPreferences>;

type PreferencesGetter<T> = Getter<IPreferencesState, PreferencesGetters, T>;

export interface Getters {
    tournaments: PreferencesGetter<IFavouriteItem[]>;
    tournamentsEvents: PreferencesGetter<Match[]>;
    tournamentIds: PreferencesGetter<number[]>;
    _userState: PreferencesGetter<IUserPreferences>;
    marketIds: PreferencesGetter<number[]>;
    _userId: PreferencesGetter<number | DEFAULT_USER_ID>;
    pinnedEventIds: PreferencesGetter<number[]>;
    pinnedEvents: PreferencesGetter<Match[]>;
    [key: string]: PreferencesGetter<any>;  // to satisfy vuex typings
}

export type PreferencesGetters = ComputedGetters<Getters>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/preferences/types.ts